import React, { useEffect, useState } from "react"
import OnlineCourses from "../allcourses/OnlineCourses"
import Heading from "../common/heading/Heading"
import "../allcourses/courses.css"
import { coursesCard } from "../../dummydata"
import backend from "../api"
import Awrapper from "../about/Awrapper"

const HAbout = () => {
  const [websiteSetting,setwebsiteSetting]=useState({})
  const getWebsiteSettings = async () => {
    try{
    const resp = await backend.get(`/api/v1/website-setting`);
    setwebsiteSetting(resp?.data)  
  
    }catch(error){
      console.log("error",error)
    }
  }
  
  useEffect(()=>{
    getWebsiteSettings()
  },[])
  return (

    <>
      <Awrapper websiteSetting={websiteSetting} />

      {/* vision */}
      <section className='homeAbout'>
        <div className='container'>
          <Heading subtitle='our Vision' title='Empowering minds through modern learning' />
          <div class="vision-container">
  <div class="vision-box">
    <p class="vision-text">
      “{websiteSetting?.vision}”
    </p>
  </div>
</div>
        </div>
      </section>
      <section className='homeAbout'>
        <div className='container'>
          <Heading subtitle='our courses' title='explore our popular courses' />

          {/* <div className='coursesCard'>
            <div className='grid2'>
              {coursesCard.slice(0, 3).map((val) => (
                <div className='items'>
                  <div className='content flex'>
                    <div className='left'>
                      <div className='img'>
                        <img src={val.cover} alt='' />
                      </div>
                    </div>
                    <div className='text'>
                      <h1>{val.coursesName}</h1>
                      <div className='rate'>
                        <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <label htmlFor=''>(5.0)</label>
                      </div>
                      <div className='details'>
                        {val.courTeacher.map((details) => (
                          <>
                            <div className='box'>
                              <div className='dimg'>
                                <img src={details.dcover} alt='' />
                              </div>
                              <div className='para'>
                                <h4>{details.name}</h4>
                              </div>
                            </div>
                            <span>{details.totalTime}</span>
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className='price'>
                    <h3>
                      {val.priceAll} / {val.pricePer}
                    </h3>
                  </div>
                  <button className='outline-btn'>ENROLL NOW !</button>
                </div>
              ))}
            </div>
          </div> */}
        </div>
        <OnlineCourses />
      </section>
    </>
  )
}

export default HAbout
